// Polyfill for Object.hasOwn (ES2022) - 兼容旧浏览器
if (!Object.hasOwn) {
  Object.hasOwn = function(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop)
  }
}

// 兼容 ios12 IntersectionObserver
import 'intersection-observer';
// 样式导入,提高qxs-ui组件库的优先级
import './styles/variable.styl'
import './styles/main.styl'
import './styles/tailwind.css'
import QxsUi from 'qxs-ui'
import './utils/vue-error-handler'
import './utils/tencent'
import './utils/vConsole'

import Vue from 'vue'
import App from './App.vue'
import store from './store'
import routerFun from './router'
import dayjs from '@/utils/dayjs'
import Moment from 'moment'
import * as filter from './utils/filters'
import './utils/directive'
import './utils/tim'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import vueWechatTitle from 'vue-wechat-title'

import Msg from 'vue-message'
Vue.use(Msg, {
  text: '未知错误！',
  background: 'rgba(0,0,0,0.5)'
})


import 'swiper/dist/css/swiper.css'
import 'mint-ui/lib/style.css'
import './styles/mint-ui-customize.css'
import 'qxs-ui/lib/theme/qxs-ui.css'
import { wxJumpPlugin } from './utils/wxConfig'
import { isMiniprogram } from './utils/environment'

import { initAnalysysAgent } from '@/utils/analysys-agent'

import axios from './utils/request'
import { API } from './service/apiConfig'
Vue.prototype.$axios = axios
Vue.prototype.$API = API

import vantUI from '@/utils/vant-ui.js'
vantUI(Vue)

// 自动注册全局组件
import '@/components/autoRegister.js'

import { add, subtract, multiply, divide } from "@/utils/bignumber"
Vue.prototype.$add = add
Vue.prototype.$subtract = subtract
Vue.prototype.$multiply = multiply
Vue.prototype.$divide = divide

import { nanoid } from 'nanoid'
Vue.prototype.$nanoid = nanoid

Vue.prototype.$eventBus = new Vue()

/**
 * 阿里云前端监控（ARMS）代码
 */
import { loadARMS, parseUid, setUid } from '@/utils/ali-log.js'
if (['publish'].includes(process.env.VUE_APP_BUILD_ENV)) {
  loadARMS()
  setUid(parseUid())
}

// 监听网络状态，上报统计时长
import { createNetworkEventListener } from '@/utils/record-time.js'
createNetworkEventListener()?.add()


// 自动加载 svg 图标
const req = require.context('@/assets/svgicons', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)

import Clipboard from "vue-clipboard2";
Vue.use(Clipboard)

if (window.__isMiniprogram === undefined) {
  isMiniprogram().then(res => {
    window.__isMiniprogram = res
  })
}
Vue.config.ignoredElements = ['wx-open-launch-weapp']
//注册全局过滤器
Object.keys(filter).forEach(item => Vue.filter(item, filter[item]))
Vue.prototype.$moment = Moment

Vue.prototype.$dayjs = dayjs

Vue.use(wxJumpPlugin)
Vue.use(QxsUi)
Vue.config.productionTip = false

Vue.use(vueWechatTitle)
Vue.use(VueAwesomeSwiper)
Vue.config.productionTip = false
initAnalysysAgent()
// 先判断环境，再再挂载router
routerFun().then(router => {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')

})

// 部分不支持vw单位的浏览器，无感降级到rem单位。
// vwPolyfill.init()

